import i18next from "@config/i18next";

import { GenericErrorToastFactory } from "@containers/Toastify";

export const showGenericErrorToast = (customMessage?: string | null) => {
  const toast = GenericErrorToastFactory(
    i18next.t(`batwork_pwa_generic.something_went_wrong`),
    "batwork-generic-error",
  );

  toast(customMessage);
};
